import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { Routes, RouterModule } from '@angular/router';

import { IonicModule } from '@ionic/angular';

import { DetailClassroomPage } from './detail-classroom.page';
import { MenuHome } from './detail-classroom.page';
import { InputNilaiPage } from '../input-nilai/input-nilai.page';

const routes: Routes = [
  {
    path: '',
    component: DetailClassroomPage
  }
];

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    RouterModule.forChild(routes)
  ],
  declarations: [DetailClassroomPage, MenuHome, InputNilaiPage],
  entryComponents:[MenuHome,InputNilaiPage]
})
export class DetailClassroomPageModule {}
